import React from 'react';
import { Chip, Box, Typography, alpha } from '@mui/material';

export const classificacaoColors: Record<string, string> = {
  Otimo: '#2e7d32',
  Bom: '#1565c0',
  Suficiente: '#e65100',
  Regular: '#c62828',
};

export const getClassificacaoColor = (classificacao: string): string => {
  return classificacaoColors[classificacao] || '#757575';
};

interface ClassificacaoBadgeProps {
  classificacao: string;
  variant?: 'chip' | 'dot' | 'text';
  size?: 'small' | 'medium';
}

const ClassificacaoBadge: React.FC<ClassificacaoBadgeProps> = ({
  classificacao,
  variant = 'chip',
  size = 'medium',
}) => {
  const color = getClassificacaoColor(classificacao);
  const fontSize = size === 'small' ? '0.75rem' : '0.8125rem';

  if (variant === 'text') {
    return (
      <Typography
        component="span"
        sx={{ color, fontWeight: 600, fontSize }}
      >
        {classificacao}
      </Typography>
    );
  }

  if (variant === 'dot') {
    return (
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: color,
            flexShrink: 0,
          }}
        />
        <Typography
          component="span"
          sx={{ color, fontWeight: 600, fontSize }}
        >
          {classificacao}
        </Typography>
      </Box>
    );
  }

  return (
    <Chip
      label={classificacao}
      size={size === 'small' ? 'small' : 'medium'}
      sx={{
        backgroundColor: alpha(color, 0.12),
        color,
        fontWeight: 600,
        fontSize,
        height: size === 'small' ? 24 : 32,
      }}
    />
  );
};

export default ClassificacaoBadge;
